"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-personal kiwi-personal--brite"
  }, [_c('div', {
    staticClass: "container py-4 kiwi-personal-inner"
  }, [_c('h1', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_client')) + " ")]), _vm.server && _vm.server.server && !_vm.readyToShowOptions ? _c('div') : _vm.server && _vm.server.server ? _c('div', [_vm.addedNetworkToExisting ? _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_added_to_existing')) + " ")])]) : _c('div', [_c('p', {
    staticClass: "mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('personal_connect_to', {
        network: `<b>${_vm.server.server}</b>`
      }))
    }
  }), _c('div', {
    staticClass: "d-flex flex-column align-items-center gap-2"
  }, [_vm.hasOtherTab ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNetworkToExistingTab
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_add_existing_tab')) + " ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.addNetwork();
      }
    }
  }, [_vm._v(" Add network to Kiwi ")]), _c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.addNetwork(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_connect_temporary')) + " ")])])])]) : _c('div', [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_addjoin')) + " ")]), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_return')) + " ")]), _c('button', {
    staticClass: "btn btn-primary mb-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addEmptyNetwork
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_add')) + " ")]), _c('div', [_vm.networks.length > 0 ? _c('a', {
    staticClass: "btn btn-link kiwi-personal-existing-networks",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleStateBrowser.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('personal_saved')) + " ")]) : _vm._e()])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];